import {
  Icon,
  InternalLinkButton,
  TextEllipsis,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { formattedStartToEndDuration } from '../../../../utils';
import * as Styled from './styles';
import * as SX from './sx';
import type { EducationItemProps as Props } from './types';

export const EducationItem = memo(({ className, item, index }: Props) => {
  return (
    <Card
      className={classnames('EducationItem', className)}
      sx={SX.root}
      key={index}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Stack direction="row" gap={2}>
          <Styled.Image src={item.school?.logo ?? ''}>
            <Icon sxx={SX.icon} size={21} name="apartment-rounded" />
          </Styled.Image>
          <Stack sx={{ width: '100%' }} overflow="hidden" gap={0.25}>
            <InternalLinkButton to={item.school?.url}>
              <Typography variant="h6">{item.school?.name}</Typography>
            </InternalLinkButton>
            <Stack overflow="hidden">
              <TextEllipsis variant="body4" color="black">
                {item.degree_name}
                {item.degree_name && item.field_of_study && ', '}
                {item.field_of_study}
              </TextEllipsis>
            </Stack>

            {item.date?.start && (
              <Typography variant="body4" color="grey.500">
                {formattedStartToEndDuration(item.date.start, item.date?.end)}
              </Typography>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
});

EducationItem.displayName = 'EducationItem';
